import { type EntityId } from '@canvas/model/ecs';

import { getEntityIdFromDOM } from './util';

export const getEntityId = (target: EventTarget | null): EntityId | undefined => {
  if (!target) {
    return undefined;
  }

  const canvasEntityId = getEntityIdFromDOM(target);

  if (canvasEntityId) {
    return canvasEntityId as EntityId;
  }

  return undefined;
};
